<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
